/* @flow */

import { MILLISECONDS_PER_MINUTE } from '../dateTime/Format';

// Delay between two checks of the state of a scheduled recording that has just been created (in ms)
export const SCHEDULED_RECORDING_CHECK_TIMEOUT: number = 500;

// Max number of attempts when checking that a new scheduled recording is OK
export const SCHEDULED_RECORDING_MAX_CHECK_COUNT: number = MILLISECONDS_PER_MINUTE / SCHEDULED_RECORDING_CHECK_TIMEOUT;
